import { useEffect } from 'react'

const isiOsSafari = () => /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent)

const OnVideoToggleFullScreen = (videoRef, options = {}) => {
  const {
    callback = () => false,
  } = options

  const iOsSafari = isiOsSafari()

  const onEnterFullScreen = () => {
    callback(true)
  }
  const onExitFullScreen = () => {
    callback(false)
  }
  const onToggleFullScreen = () => {
    callback(Boolean(document.fullscreenElement))
  }

  const startEvent = 'webkitbeginfullscreen'
  const endEvent = 'webkitendfullscreen'

  useEffect(() => {
    const video = videoRef?.wrapper?.children?.[0]

    if (videoRef && callback) {
      if (iOsSafari) {
        video.addEventListener(startEvent, onEnterFullScreen)
        video.addEventListener(endEvent, onExitFullScreen)
        return () => {
          video.removeEventListener(startEvent, onEnterFullScreen)
          video.removeEventListener(endEvent, onExitFullScreen)
        }
      }

      video.addEventListener('fullscreenchange', onToggleFullScreen)
      return () => {
        video.removeEventListener('fullscreenchange', onToggleFullScreen)
      }
    }

    return () => false
  }, [videoRef?.wrapper, onEnterFullScreen, onExitFullScreen])
}

export default OnVideoToggleFullScreen
